import { BmHttp } from "../utils/Global";

export const IniciarContextoSoporte = async (payload) => {
  const { data } = await BmHttp().post("support/context", payload);
  return data;
};

export const FinalizarContextoSoporte = async (id) => {
  const { data } = await BmHttp().post(`support/context/${id}/close`);
  return data;
};

export const ListarSesionesSoporte = async (params = {}) => {
  const { data } = await BmHttp().get("support/sessions", { params });
  return data;
};

export const ListarHistorialAccesos = async (params = {}) => {
  const { data } = await BmHttp().get("security/access-log", { params });
  return data;
};

export const ListarAuditEvents = async (params = {}) => {
  const { data } = await BmHttp().get("security/audit-events", { params });
  return data;
};
